// Belgisch Minimum Algemeen Rekeningstelsel (MAR) — de rekeningen die in dit
// boekhoudprogramma gebruikt worden. Gebruikt voor autocomplete bij het ingeven
// van een rekeningnummer op een boekingslijn.
export const MAR_ACCOUNTS = [
  { code: "170000", name: "Schulden op meer dan een jaar (krediet)" },
  { code: "173000", name: "Kredietinstellingen — leningen op lange termijn" },
  { code: "420000", name: "Schulden op meer dan een jaar die binnen het jaar vervallen" },
  { code: "423000", name: "Schulden op meer dan een jaar die binnen het jaar vervallen" },
  { code: "400000", name: "Klanten / dagontvangsten" },
  { code: "411000", name: "Terug te vorderen btw" },
  { code: "440000", name: "Leveranciers" },
  { code: "451000", name: "Te betalen btw" },
  { code: "453000", name: "Ingehouden bedrijfsvoorheffing" },
  { code: "454000", name: "RSZ" },
  { code: "455000", name: "Bezoldigingen" },
  { code: "499100", name: "Te klasseren (bank)" },
  { code: "499999", name: "Te controleren boekingsverschil" },
  { code: "550000", name: "Bank" },
  { code: "550100", name: "Viva" },
  { code: "550200", name: "Viva" },
  { code: "570000", name: "Kassen" },
  { code: "580000", name: "Interne overboekingen" },
  { code: "604000", name: "Aankopen handelsgoederen 0%" },
  { code: "604001", name: "Commissiekosten Lotto" },
  { code: "604006", name: "Aankopen handelsgoederen 6% — voeding" },
  { code: "604012", name: "Aankopen handelsgoederen 12%" },
  { code: "604021", name: "Aankopen handelsgoederen 21%" },
  { code: "608000", name: "Ontvangen kortingen, ristorno's en rabatten" },
  { code: "610000", name: "Huur en huurlasten" },
  { code: "611000", name: "Onderhoud en herstellingen" },
  { code: "612100", name: "Elektriciteit en gas" },
  { code: "613000", name: "Erelonen en beheerskosten" },
  { code: "613100", name: "Telecom en internet" },
  { code: "613200", name: "Erelonen boekhouder en administratie" },
  { code: "613500", name: "Autokosten" },
  { code: "613510", name: "Brandstof" },
  { code: "614000", name: "Diverse kosten" },
  { code: "615000", name: "Diverse kosten" },
  { code: "700000", name: "Verkopen 0%" },
  { code: "700001", name: "Verkopen Lotto" },
  { code: "700006", name: "Verkopen 6%" },
  { code: "700012", name: "Verkopen 12%" },
  { code: "700021", name: "Verkopen 21%" },
  { code: "743000", name: "Diverse bedrijfsopbrengsten" },
];

const _map = Object.fromEntries(MAR_ACCOUNTS.map((a) => [a.code, a.name]));
export const marName = (code) => _map[(code || "").toString().trim()] || "";
